export const tr = {
    allSpecialists: 'Tüm uzmanlar',
    becomeSpecialist: 'Uzman ol',
    customer: 'Sipariş veren',
    myCustomers: 'Müşterilerim',
    myOwnCampaigns: 'Kampanyalarım',
    myProfile: 'Profilim',
    mySpecialist: 'Uzmanım',
    specialistsOfYandexDirect: 'Yandex.Direct ayarlama uzmanları'
};
